import request from '@/libs/request'

// 平台角色列表
export function adminRoleList (data) {
  return request({
    url: `role/list`,
    method: 'get',
    params: data
  })
}
// 角色
export function authAll () {
  return request({
    url: `role/getAuthTree`,
    method: 'get'
  })
}

// 启用禁用用户
// export function changeStatus (data) {
//   return request({
//     url: `admin/changeStatus`,
//     method: 'post',
//     data: data
//   })
// }

// 删除平台用户
export function delRole (id) {
  return request({
    url: `role/delete/${id}`,
    method: 'post'
  })
}

// 添加角色
export function addRole (data) {
  return request({
    url: `role/edit`,
    method: 'post',
    data: data
  })
}

// 角色信息
export function roleInfo (id) {
  return request({
    url: `role/info/${id}`,
    method: 'get'
  })
}
